import * as React from "react"
import {Box, Divider} from "@mui/material";
import {ButtonIconSeeker} from "@ui-seeker/core";

import {matcherSKUsImageSize} from "../../@signals";


export default function MatcherSKUsTargetActionsZoom() {
	return <Box sx={{ display: 'flex', gap: 2 }}>
		<ButtonIconSeeker
			disabled={matcherSKUsImageSize.value === 0}
			icon="magnifying-glass-minus"
			onClick={() => matcherSKUsImageSize.value -= 1}
			tooltip="zoom -"
		/>

		<ButtonIconSeeker
			disabled={matcherSKUsImageSize.value === 2}
			icon="magnifying-glass-plus"
			onClick={() => matcherSKUsImageSize.value += 1}
			tooltip="zoom +"
		/>

		<Divider orientation="vertical" flexItem />
	</Box>
}